import { z } from 'zod';
import type { BlockDefinition } from '../types';
import { sanitizedHtmlProps } from '../lib/sanitize';

export const richTextSchema = z.object({
  html: z.string().min(1).max(50000),
  width: z.enum(['narrow', 'wide', 'full']).default('narrow'),
});

export type RichTextData = z.infer<typeof richTextSchema>;

const RICH_TAGS = [
  'a', 'b', 'blockquote', 'br', 'code', 'div', 'em', 'figure', 'figcaption',
  'h2', 'h3', 'h4', 'h5', 'h6', 'hr', 'i', 'iframe', 'img', 'li', 'mark',
  'ol', 'p', 'pre', 's', 'small', 'span', 'strong', 'sub', 'sup',
  'table', 'tbody', 'td', 'tfoot', 'th', 'thead', 'tr', 'u', 'ul',
];

const RICH_ATTR = [
  'href', 'title', 'target', 'rel', 'class', 'src', 'alt', 'loading',
  'width', 'height', 'allow', 'allowfullscreen', 'frameborder',
  'referrerpolicy',
];

export function RichTextRenderer({ html, width = 'narrow' }: RichTextData) {
  return (
    <section className={`v5-rich-text v5-rich-text--${width}`}>
      <div
        className="v5-prose"
        dangerouslySetInnerHTML={sanitizedHtmlProps(html, {
          allowedTags: RICH_TAGS,
          allowedAttr: RICH_ATTR,
        })}
      />
    </section>
  );
}

export const richTextBlock: BlockDefinition<RichTextData> = {
  meta: {
    type: 'rich-text',
    label: 'Texto enriquecido',
    description: 'Bloque de texto largo con editor WYSIWYG (Tiptap). HTML sanitizado.',
    category: 'content',
    icon: 'type',
  },
  schema: richTextSchema,
  defaults: {
    html: '<p>Escribe aquí tu contenido.</p>',
    width: 'narrow',
  },
  fields: [
    { name: 'html', label: 'Contenido', type: 'richtext', required: true },
    {
      name: 'width',
      label: 'Ancho',
      type: 'select',
      options: [
        { label: 'Estrecho', value: 'narrow' },
        { label: 'Ancho', value: 'wide' },
        { label: 'Completo', value: 'full' },
      ],
    },
  ],
  Renderer: RichTextRenderer,
};
